//Cloudinary Video Player
import cloudinary from 'cloudinary-video-player';
import "cloudinary-video-player/cld-video-player.min.css";
window.cloudinary = cloudinary;

//Algolia
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import 'instantsearch.css/themes/satellite.css';
import { history } from 'instantsearch.js/es/lib/routers';
import { clearRefinements, configure, searchBox, index } from 'instantsearch.js/es/widgets';
import {
    connectInfiniteHits,
    connectDynamicWidgets,
    connectRange,
    connectToggleRefinement,
    connectRefinementList,
    connectSortBy,
    connectClearRefinements,
    connectMenu
} from 'instantsearch.js/es/connectors';

const widgets = {
    clearRefinements,
    configure,
    searchBox,
    index
};
const connectors = {
    connectInfiniteHits,
    connectDynamicWidgets,
    connectRange,
    connectToggleRefinement,
    connectRefinementList,
    connectSortBy,
    connectClearRefinements,
    connectMenu
}
const routers = {
    history
}

window.algoliasearch = algoliasearch;
window.instantsearch = instantsearch;
window.algolia = {
    routers,
    connectors,
    widgets
}

import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import { createLocalStorageRecentSearchesPlugin } from '@algolia/autocomplete-plugin-recent-searches';
import '@algolia/autocomplete-theme-classic';
window.autocomplete = autocomplete;
window.getAlgoliaResults = getAlgoliaResults;
window.createLocalStorageRecentSearchesPlugin = createLocalStorageRecentSearchesPlugin;

import aa from 'search-insights';
window.aa = aa;

import 'jquery-ui-touch-punch';
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;
